import { defineComponent as _defineComponent } from 'vue'
import {
  useI18n } from "@/composables/useI18n";

import {
  ref,
  unref,
  watch
} from 'vue';

import {
  CustomerState,
} from "@/Enums";

import {
  debounce
} from "@/scripts/Common/HelperFunctions";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerSearchFilter',
  emits: [
  'onSearchFilterChange'
],
  setup(__props, { emit: emits }) {

const {
  t,
} = useI18n();



const companyName = ref<string | undefined>();
const phoneNumber = ref<string | undefined>();
const email = ref<string | undefined>();
const contactName = ref<string | undefined>();
const selectedCustomerState = ref<CustomerState | undefined>();

const customerStateItems = [
  { text: t('state_interested'), state: CustomerState.Interested },
  { text: t('state_canceled'), state: CustomerState.Canceled },
  { text: t('state_confirmed'), state: CustomerState.Confirmed },
  { text: t('state_contracted'), state: CustomerState.Contracted },
];

const onHandleChange = () => {
  emits('onSearchFilterChange', {
    customerState: unref(selectedCustomerState),
    companyName: unref(companyName),
    phoneNumber: unref(phoneNumber),
    email: unref(email),
    contactName: unref(contactName),
  });
};

const onHandleClearCompanyName = () => {
  companyName.value = undefined;
};

const onHandleClearPhoneNumber = () => {
  phoneNumber.value = undefined;
};

const onHandleClearEmail = () => {
  email.value = undefined;
};

const onHandleClearContactName = () => {
  contactName.value = undefined;
};

const onHandleClearCustomerState = () => {
  selectedCustomerState.value = undefined;
};

watch([companyName, phoneNumber, email, contactName, selectedCustomerState], debounce(() => {
  onHandleChange();
}));

return { __sfc: true,t, emits, companyName, phoneNumber, email, contactName, selectedCustomerState, customerStateItems, onHandleChange, onHandleClearCompanyName, onHandleClearPhoneNumber, onHandleClearEmail, onHandleClearContactName, onHandleClearCustomerState }
}

})